<div class="modal-header">
    <h5 class="modal-title">İzin Detayı</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body leave-detail-body">

    <div class="detail-grid">

        <div class="detail-item">
            <span class="label">Ad Soyad:</span>
            <span class="value">{{ row?.name }} {{ row?.lastName }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Departman:</span>
            <span class="value">{{ row?.depertmentName }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Sicil No:</span>
            <span class="value">{{ row?.registrationNumber || '-' }}</span>
        </div>

        <div class="detail-item">
            <span class="label">İzin Türü:</span>
            <span class="value">{{ row?.typeName }}</span>
        </div>

        <div class="detail-item">
            <span class="label">İzin Gün Sayısı:</span>
            <span class="value">{{ row?.leaveDay }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Başlangıç Tarihi:</span>
            <span class="value">{{ row?.startDate | date:'dd.MM.yyyy' }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Bitiş Tarihi:</span>
            <span class="value">{{ row?.endDate | date:'dd.MM.yyyy' }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Durum:</span>
            <span class="value">
                {{ row?.status === 2 ? 'Onaylandı' : row?.status === 1 ? 'Bekliyor' : 'Reddedildi' }}
            </span>
        </div>

        <div class="detail-item">
            <span class="label">Açıklama:</span>
            <span class="value">{{ row?.description }}</span>
        </div>

        <div class="detail-item">
            <span class="label">TC No:</span>
            <span class="value">{{ row?.tc || '-' }}</span>
        </div>

        <div class="detail-item">
            <span class="label">Oluşturma Tarihi:</span>
            <span class="value">{{ getByDate(row?.cratedAt, row?.updateAt) }}</span>
        </div>

        <div class="detail-item">
            <span class="label">İşlem Yapan Kullanıcı:</span>
            <span class="value">{{ row?.appUserName }} {{ row?.appUserLastName }}</span>
        </div>

    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Kapat</button>
</div>